import clsx from 'clsx'
import {toAbsoluteUrl} from '../../../helpers'

type FormErrorProps = {
  message: string
  iconPath?: string
  className?: string
  textClassName?: string
}
export const FormError = ({
  message,
  iconPath = '/media/gori/invalid.svg',
  className,
  textClassName = '',
}: FormErrorProps) => {
  return (
    <div className={clsx('fv-plugins-message-container d-flex gap-1', className)}>
      <img alt='err' src={toAbsoluteUrl(iconPath)} width={16} height={20} />
      <div className={clsx('fv-help-block text-danger', textClassName)}>
        <span role='alert'>{message}</span>
      </div>
    </div>
  )
}
